import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: {},
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      sessionStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    },

    setTokens: (_, action) => {
      const { access_token, refresh_token } = action.payload;
      sessionStorage.setItem("access_token", access_token);
      sessionStorage.setItem("refresh_token", refresh_token);
    },

    removeTokens: () => {
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
    },

    setUserData: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      localStorage.setItem("user_data", JSON.stringify(action.payload));
    },
  },
});

export const { logout, setTokens, removeTokens, setUserData } =
  authSlice.actions;
export default authSlice.reducer;
